import BenefitCard from './BenefitCard'

export default BenefitCard;